import { get } from '..';

const getSessionMessages = (sessionId: string) => get(`chatbot-api/chat-sessions/${sessionId}/messages`);

export default getSessionMessages;
